
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/childhood-strides",
      function () {
        return require("private-next-pages/stories/childhood-strides.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/childhood-strides"])
      });
    }
  